module.exports = __webpack_public_path__ + "img/SP_CN.419b0419.svg";